module.exports = __webpack_public_path__ + "static/media/solo-branco.04071481.svg";